import GlobalStyle from './GlobalStyle';

export * from './GlobalStyle';

export default GlobalStyle;
